import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// Import Global Components
import Button from '../Button';
// Import Hooks
import { PIN_UNBLOCK_STATES } from '../../hooks/usePinUnblock';

// Offered only while the PIN is locked and today's unlock is still available (State B),
// and kept in place behind the open dialog (State C): a control that would be refused is
// never shown.
const VISIBLE_STATES = [PIN_UNBLOCK_STATES.LOCKED, PIN_UNBLOCK_STATES.CONFIRMING];

const UnblockPinButton = ({ state, onClick, size }) => {
  const intl = useIntl();

  if (!VISIBLE_STATES.includes(state)) return null;

  return (
    <Button
      buttonText={intl.messages['unlock-pin-button']}
      page="unlock"
      buttonFor="pin"
      type="secondary"
      size={size}
      onClick={onClick}
    />
  );
};

UnblockPinButton.propTypes = {
  state: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string,
};

UnblockPinButton.defaultProps = {
  size: undefined,
};

export default UnblockPinButton;
